module.exports = __webpack_public_path__ + "static/media/more.e6010f0b.svg";